import useGame from "./stores/useGame"

import './style.css'

export default function UI()
{
    

    const play =  useGame((state) => state.play)
    const rotate =  useGame((state) => state.rotate)

    const reset = useGame((state) => state.reset)
    const solarOpen = useGame((state) => state.solarOpen)
    const solarFlat = useGame((state) => state.solarFlat)

    const togglePlay = useGame((state) => state.togglePlay)
    const toggleRotate = useGame((state) => state.toggleRotate)
    const toggleOpenAnim = useGame((state) => state.toggleOpenAnim)
    const toggleSolarFlat = useGame((state) => state.toggleSolarFlat)
    

        return <>

        <div className='banner-top'>
            <img src="./DSL_Logo_stackedonWHT_Transp_Web_120.png" className="image-wrap" onClick={()=>{window.open('https://www.darkstarlabs.io/')}}></img>
            <div className="action-card-row" onClick={()=>{window.open('https://www.darkstarlabs.io/contact')}}>
                <div className='text-button-row'>Talk to the team</div>
                <div className='dot'>?</div>    
                
            </div> 
        </div> 
  
        <div className='interface'>

        { play === false && solarOpen === false && 
            <div className="action-card" onClick={togglePlay}>
                <div className='dot'> + </div> 
                
                <div className='text-button'>Expand</div>
            </div> 
        }

        { play === false && rotate === false && solarOpen === true && solarFlat === false &&
            <div className="action-card" onClick={togglePlay}>
                <div className='dot'> + </div> 
                
                <div className='text-button'>Retract</div>
            </div> 
        }

        { play === false && rotate === false && solarOpen === true &&

            <div className="action-card" onClick={toggleRotate}>
                <div className='dot'> + </div> 
                
                <div className='text-button'>Realign</div>
            </div> 
        }

        </div> 

   
        {/* <div id="p1" className='p'>
            <div className='heading'>Chemistry & Camera <span style={{color: '#F2330D'}}>ChemCam, Mastcam</span></div>
            <div className='body'>The ChemCam performs chemical and microscopic reconnaissance.</div>
            <div className='body'>Mastcam captures color images and video footage of Mars.</div>
            <div className='reset' onClick={() => {reset()}}>BACK</div>
        </div> 

        <div id="p2" className='p'>
            <div className='heading'>UHF Antenna</div>
            <div className='body'>This antenna is for communications with orbiting spacecraft.</div>
            <div className='reset' onClick={() => {reset()}}>BACK</div>
        </div> 

        <div id="p3" className='p'>
            <div className='heading'>Environmental Monitoring Station <span style={{color: '#F2330D'}}>REMS</span></div>
            <div className='body'>REMS acts as a weather station, measuring atmospheric pressure, humidity, wind currents, and ultraviolet radiation from the sun.</div>
            <div className='reset' onClick={() => {reset()}}>BACK</div>
        </div> 

        <div id="p4" className='p'>
            <div className='heading'>Dynamic Albedo of Neutrons & Radiation Assessment Detector <span style={{color: '#F2330D'}}>DAN, RAD</span></div>
            <div className='body'>The DAN instrument's mission is to search for signs of water.</div>
            <div className='body'>RAD is about the size of a six-pack of soda. It measures the type and amount of radiation present.</div>
            <div className='reset' onClick={() => {reset()}}>BACK</div>
        </div> 

        <div id="p5" className='p'>
            <div className='heading'>Chemistry & Mineralogy X-Ray Diffraction / X-Ray Fluorescence Instrument <span style={{color: '#F2330D'}}>CheMin</span></div>
            <div className='body'>CheMin is an X-ray diffraction/X-ray fluorescence instrument located inside the rover that performs chemical analysis of powdered rock samples.</div>    
            <div className='reset' onClick={() => {reset()}}>BACK</div>
        </div> 

        <div id="p6" className='p'>
            <div className='heading'>Mars Descent Imager <span style={{color: '#F2330D'}}>MARDI</span></div>
            <div className='body'>MARDI captured images during the spacecraft's descent.</div>
            <div className='reset' onClick={() => {reset()}}>BACK</div>
        </div> 

        <div id="p7" className='p'>
            <div className='heading'>Robotic arm instruments <span style={{color: '#F2330D'}}>MAHLI, APXS, CHIMRA, Drill</span></div>
            <div className='body'>The Robotic Arm maneuvers instruments to analyze rocks and soil.</div>
            <div className='reset' onClick={() => {reset()}}>BACK</div>
        </div>  */}

    </>
}





